'use strict';
'use es6';

//import { logError } from 'pricing-pages-ui/actions/ErrorActions';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPurchaseMotionData = undefined;

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _dispatchAndLogError = require('pricing-pages-unified-ui/utils/dispatchAndLogError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchPurchaseMotionData = exports.fetchPurchaseMotionData = function fetchPurchaseMotionData(getMerchandiseCatalog) {
  return function (dispatch) {
    dispatch({ type: _ActionTypes2.default.PURCHASE_MOTION_DATA_REQUESTED });
    return getMerchandiseCatalog().then(function (data) {
      var _data$metadata = data.metadata,
          availableTrials = _data$metadata.availableTrials,
          customerCurrencyCode = _data$metadata.customerCurrencyCode,
          parcels = _data$metadata.parcels,
          productBasedOffers = _data$metadata.productBasedOffers,
          productCatalog = _data$metadata.productCatalog,
          purchaseMotionsByLocation = data.purchaseMotionsByLocation;

      dispatch({
        type: _ActionTypes2.default.MERCHANDISE_RECEIVED,
        payload: productCatalog
      });
      dispatch({
        type: _ActionTypes2.default.CUSTOMER_CURRENCY_CODE_RECEIVED,
        payload: customerCurrencyCode
      });
      dispatch({
        type: _ActionTypes2.default.AVAILABLE_TRIALS_RECEIVED,
        payload: availableTrials
      });
      dispatch({
        type: _ActionTypes2.default.PURCHASE_MOTIONS_BY_LOCATION_RECEIVED,
        payload: purchaseMotionsByLocation
      });
      dispatch({
        type: _ActionTypes2.default.PRODUCT_BASED_OFFERS_RECEIVED,
        payload: productBasedOffers
      });
      dispatch({
        type: _ActionTypes2.default.PARCELS_RECEIVED,
        payload: parcels
      });
      dispatch({ type: _ActionTypes2.default.PURCHASE_MOTION_DATA_SUCCEEDED });
    }).catch(function (error) {
      (0, _dispatchAndLogError.dispatchAndLogError)({
        dispatch: dispatch,
        type: _ActionTypes2.default.PURCHASE_MOTION_DATA_FAILED,
        error: error
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/PurchaseMotionActions.js
// module id = 788
// module chunks = 3 4